module.exports = __webpack_public_path__ + "img/fail_bg.0dab4f8a.jpg";